import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../global/navbar";
import Hero from "../components/hero";
// import Skills from "../components/skills";
import About from  "../components/about";
import Contact from "../components/contact";
import Footer from "../global/footer";


export default function Home () {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const targetId = decodeURIComponent(location.hash.slice(1));
    const scrollToSection = () => {
      const section = document.getElementById(targetId);

      if (!section) {
        return;
      }

      const navOffset = 90;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY - navOffset;

      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });
    };

    window.requestAnimationFrame(scrollToSection);
  }, [location.hash]);

  return(
    <>
      <Navbar />
      <Hero />
      {/* <Skills /> */}
      <About />
      <Contact />

      <Footer />
    </>
  )
}
